/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/10/20
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CreateUser from './CreateUser';
import EditUser from './EditUser';
import ViewUsers from './ViewUsers';

type Props = {
  match: {
    path: string,
    url: string,
  }
}
const UsersSection = ({ match }: Props) => (
  <Switch>
    <Route
      exact
      path={`${match.path}/`}
      component={ViewUsers}
    />
    <Route path={`${match.path}/create`} component={CreateUser} />
    <Route path={`${match.path}/:userId`} component={EditUser} />
    <Redirect to={`${match.url}`} />
  </Switch>
);

export default UsersSection;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Users/index.jsx